import { render } from "./WidgetCustomerOrderMonthly.vue?vue&type=template&id=37fea10c&scoped=true&ts=true"
import script from "./WidgetCustomerOrderMonthly.vue?vue&type=script&lang=ts"
export * from "./WidgetCustomerOrderMonthly.vue?vue&type=script&lang=ts"

import "./WidgetCustomerOrderMonthly.vue?vue&type=style&index=0&id=37fea10c&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\dobby\\dobbyshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37fea10c"]])

export default __exports__